import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import useCurrentUser from "~/modules/auth/hooks/useCurrentUser";

import FieldworkerPlanning from "../components/FieldworkerPlanning";

export default function FieldworkerPlanningScreen() {
    const user = useCurrentUser();
    if (!user) throw Error("No user found");

    return (
        <GaiaPageLayoutColumn maxWidth="xl">
            <FieldworkerPlanning baseUrl="/fieldworker/planning" />
        </GaiaPageLayoutColumn>
    );
}
